import { render, staticRenderFns } from "./c-icon.vue?vue&type=template&id=2e96f975&"
import script from "./c-icon.vue?vue&type=script&lang=js&"
export * from "./c-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports